import { render, staticRenderFns } from "./JpyPage.vue?vue&type=template&id=3d24c94d&scoped=true&"
import script from "./JpyPage.vue?vue&type=script&lang=js&"
export * from "./JpyPage.vue?vue&type=script&lang=js&"
import style0 from "./JpyPage.vue?vue&type=style&index=0&id=3d24c94d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d24c94d",
  null
  
)

export default component.exports